import React, {useContext} from 'react';
import {ApplicationActionsContext} from "./data/ApplicationDataSource";
import {Button} from "antd";
import {navigate} from "../navigation/navigationHistory";
import Icon from "antd/lib/icon";
import ls from './QuickQouteReview.less';
import {ModelContext} from "./metadata/ModelSource";
import { LikeOutlined } from "@ant-design/icons";

export function QuickQuoteReview() {

  const applicationModel = useContext(ModelContext);
  const {convertToQuote} = useContext(ApplicationActionsContext);

  const {
    systemId,
    basicPolicy: {writtenPremiumAmt: premium},
  } = applicationModel.data;

  const convertToQuoteAction = () => convertToQuote().then((app) => {
    navigate(`/application/${app.systemId}`);
  });

  return <div className={ls.root}>

    <div className={ls.premiumBadge}>
      Your estimated premium is: <span className={ls.premium}>${premium}</span>
    </div>


    <Button className={ls.applyNow} type='primary' size='large' onClick={ convertToQuoteAction  } icon={LikeOutlined}>
      Apply for the Policy!
    </Button>


  </div>;


}